<div class="auth-wrapper auth-v2">
  <app-language-selector></app-language-selector>

  <div class="auth-inner max-width row m-0">
    <div class="d-flex align-items-center p-5 l-side">
      <div
        class="w-100 d-lg-flex align-items-center justify-content-center px-5"
      >
        <img
          class="img-fluid"
          [src]="isMobile() | authHeroImage"
          alt="Login V2"
        />
      </div>
    </div>
    <!-- /Left Text-->
    <!-- Login-->
    <div *ngIf="!showOtpOptions" class="d-flex align-items-center auth-bg r-side">
      <div class="mx-auto login-form">
        <div class="company-logo" *ngIf="logo">
          <img [src]="logo" alt=""/>
        </div>
        <h2 class="card-title mb-1">
          {{ 'LOGIN.FORM_HEADER' | translate }}
        </h2>
        <p class="card-text mb-2">{{ 'LOGIN.FORM_SUBHEADER' | translate }}</p>

        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
          <div class="alert-body">
            <p>{{ error }}</p>
          </div>
        </ngb-alert>

        <form
          *ngIf="!companyInfo.isSsoEnabled || (userSSOInfo.wasChecked === true  && !userSSOInfo.isFederated)"
          class="auth-login-form mt-2"
          [formGroup]="loginForm"
          (ngSubmit)="login()"
        >
          <div class="form-group">
            <label class="form-label">{{
                'LOGIN.EMAIL_LABEL' | translate
              }}</label>
            <input
              type="text"
              tabindex="1"
              id="login-input"
              formControlName="userIdentifier"
              class="form-control"
              type="email"
              [placeholder]="
                'account@mail.com'
              "
              [ngClass]="{
                'is-invalid':
                  f?.userIdentifier.errors &&
                  (f?.userIdentifier.dirty || f?.userIdentifier.touched)
              }"
            />
            <div
              *ngIf="
                f?.userIdentifier.errors &&
                (f?.userIdentifier.dirty || f?.userIdentifier.touched)
              "
              class="invalid-feedback"
            >
              <div *ngIf="f?.userIdentifier.errors.required">
                {{ 'LOGIN.EMAIL_REQUIRED' | translate }}
              </div>
              <div *ngIf="f?.userIdentifier.errors.pattern">
                {{ 'LOGIN.EMAIL_WRONG' | translate }}
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="d-flex justify-content-between">
              <label for="login-password">{{
                  'LOGIN.PASSWORD_LABEL' | translate
                }}</label
              ><a
              routerLink="/{{ subdomain }}/authentication/forgot-password"
              class="c-company"
            ><small>{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</small></a
            >
            </div>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="passwordTextType ? 'text' : 'password'"
                formControlName="password"
                id="login-password"
                class="form-control form-control-merge"
                placeholder="············"
                aria-describedby="login-password"
                tabindex="2"
                [ngClass]="{
                  'is-invalid error':
                    f?.password.errors &&
                    (f?.password.dirty || f?.password.touched)
                }"
              />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer" (click)="togglePasswordTextType()">
                  <i *ngIf="passwordTextType" class="feather icon-eye-off"></i>
                  <i *ngIf="!passwordTextType" class="feather icon-eye"></i>
                </span>
              </div>
            </div>
            <div
              *ngIf="
                f?.password.errors && (f?.password.dirty || f?.password.touched)
              "
              class="invalid-feedback"
            >
              <div *ngIf="f?.password.errors.required">
                {{ 'LOGIN.PASSWORD_REQUIRED' | translate }}
              </div>
            </div>
          </div>
          <div *ngIf="showOtpCode">
            <hr/>
            <p class="opt-width">
              {{ 'LOGIN.OTP_CODE_GENERATED' | translate }}
            </p>
          </div>
          <div *ngIf="showOtpCode" class="form-group">
            <div class="d-flex justify-content-between">
              <label for="login-otp">{{
                  'LOGIN.OTP_LABEL' | translate
                }}</label
              >
              <a (click)="resendOtp()"
                 class="c-company"
                 [class.disabled]="timeLeft > 0">
                <small>{{ 'LOGIN.RESEND_OTP' | translate }}</small>
              </a>
            </div>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                formControlName="otpCode"
                autocomplete="one-time-code"
                id="login-otp"
                class="form-control form-control-merge"
                aria-describedby="login-otp"
                tabindex="3"
                [ngClass]="{
                  'is-invalid error':
                    f?.otpCode.errors &&
                    (f?.otpCode.dirty || f?.otpCode.touched)
                }"
              />
            </div>
            <div
              *ngIf="f?.otpCode.errors && (f?.otpCode.dirty || f?.otpCode.touched)"
              class="invalid-feedback"
            >
              <div *ngIf="f?.otpCode.errors.required">
                {{ 'LOGIN.OTP_REQUIRED' | translate }}
              </div>
              <div *ngIf="f?.otpCode.errors.invalidCode">
                {{ f?.otpCode.errors.error | translate }}
              </div>
            </div>
            <div class="opt-width" *ngIf="timeLeft > 0">
              <small>{{
                  onlySeconds ? ('LOGIN.OTP_COUNTDOWN_SECONDS_ONLY' | translate:{seconds: otpCountdownSeconds}) : ('LOGIN.OTP_COUNTDOWN_FIRST_PART' | translate:{
                    minutes: otpCountdownMinutes,
                    seconds: otpCountdownSeconds
                  })
                }} {{ 'LOGIN.OTP_COUNTDOWN_SECOND_PART' | translate }}</small>
            </div>
          </div>
          <div class="form-group">
            <button
              [disabled]="loginForm.invalid"
              class="btn btn-primary btn-block"
              tabindex="5"
              rippleEffect
            >
              {{ 'LOGIN.LOGIN_BUTTON' | translate }}
            </button>
          </div>
          <div class="form-group">
            <a (click)="resetCompanyLS()" class="c-company">{{ 'LOGIN.DIFFERENT_COMPANY' | translate }}</a>
          </div>
        </form>

        <form
          *ngIf="companyInfo.isSsoEnabled && !userSSOInfo.wasChecked"
          class="auth-login-form mt-2"
          [formGroup]="checkUserForm"
          (ngSubmit)="checkUserAuthType()"
        >
          <div class="form-group">
            <label class="form-label">{{
                subdomain === 'pepsico'
                  ? ('LOGIN.EMAIL_OR_ID_LABEL' | translate)
                  : ('LOGIN.EMAIL_LABEL' | translate)
              }}</label>
            <input
              type="text"
              tabindex="1"
              id="login-input"
              formControlName="userIdentifier"
              class="form-control"
              type="email"
              [placeholder]="
                subdomain === 'pepsico'
                  ? ('LOGIN.EMAIL_OR_ID_LABEL' | translate)
                  : 'account@mail.com'
              "
              [ngClass]="{
              'is-invalid':
                f?.userIdentifier.errors &&
                (f?.userIdentifier.dirty || f?.userIdentifier.touched)
            }"
            />
            <div
              *ngIf="
              f?.userIdentifier.errors &&
              (f?.userIdentifier.dirty || f?.userIdentifier.touched)
            "
              class="invalid-feedback"
            >
              <div *ngIf="f?.userIdentifier.errors?.required">
                {{ 'LOGIN.EMAIL_REQUIRED' | translate }}
              </div>
              <div *ngIf="f?.userIdentifier.errors?.emailOrId">
                {{ 'LOGIN.EMAIL_WRONG' | translate }}
              </div>
              <div *ngIf="f?.userIdentifier.errors?.pattern">
                {{ 'LOGIN.EMAIL_WRONG' | translate }}
              </div>
            </div>
          </div>
          <div class="form-group">
            <button
              [disabled]="checkUserForm.invalid"
              class="btn btn-primary btn-block"
              tabindex="4"
              rippleEffect
            >
              {{ 'LOGIN.LOGIN_BUTTON' | translate }}
            </button>
          </div>
          <div class="form-group">
            <a (click)="resetCompanyLS()" class="c-company">{{ 'LOGIN.DIFFERENT_COMPANY' | translate }}</a>
          </div>
        </form>
      </div>
    </div>
    <!-- /Login-->
    <div *ngIf="showOtpOptions && loggedUser.isSmsLinkActive" class="d-flex align-items-center auth-bg r-side">
      <div class="mx-auto login-form">
        <div class="company-logo" *ngIf="logo">
          <img [src]="logo" alt=""/>
        </div>
        <p class="card-text mb-2">{{ 'LOGIN.OTP_OPTIONS' | translate }}</p>

        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
          <div class="alert-body">
            <p>{{ error }}</p>
          </div>
        </ngb-alert>

        <app-login-otp-code [hasPhoneNumber]="!!loggedUser.phoneNumber"
                            [platformUrl]="subdomain"
                            [user]="loggedUser"
                            (close)="showOtpOptions = false"
                            (onCodeSent)="onOtpCodeSent($event)"
        ></app-login-otp-code>
      </div>
    </div>
  </div>
</div>
